import { createRouter, createWebHistory } from 'vue-router'
import { APP_ROUTES } from '@/config/routes'
import { useAuthStore } from '@/app/store/auth.store'
import i18n from '@/app/plugins/i18n'
import { buildRouterConfig } from '@/config/router'

const routes = buildRouterConfig()

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || '/'),
  routes
})

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({
      name: APP_ROUTES.AUTH?.children?.LOGIN?.name,
      query: { redirect: to.fullPath }
    })
  }

  next()
})

router.afterEach((to) => {
  if (to.meta.titleKey) {
    const title = (i18n.global as any).t(to.meta.titleKey as string)
    document.title = `${title} - BP-CRM`
  } else {
    document.title = 'BP-CRM'
  }
})

export default router
